// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__25IQG","obliqueLineWrap":"membershipbadge_obliqueLineWrap__33d-I","obliqueLine":"membershipbadge_obliqueLine__1HF1H"};